import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHookSection() {
  return <section className="w-full bg-slate-800 py-16 md:py-24" data-id="element-126">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-127">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-8 text-lg md:text-xl text-slate-200 leading-relaxed" data-id="element-128">
          <p className="font-medium text-amber-100 border-l-4 border-amber-500 pl-6 italic" data-id="element-129">
            "¿Alguna vez te has preguntado a dónde van a parar los millones de
            productos que la gente devuelve a Amazon, Target o Walmart cada día?
            La mayoría están nuevos, pero las tiendas no pueden volver a
            exhibirlos."
          </p>

          <p data-id="element-130">
            Ahí es donde está tu oportunidad. Existe un sistema exacto para
            comprar esos "retornos" por centavos y convertirlos en billetes de{' '}
            <span className="text-amber-400 font-bold" data-id="element-131">$20, $50 y $100</span>{' '}
            usando solo tu teléfono y Facebook Marketplace.
          </p>
        </motion.div>
      </div>
    </section>;
}